import { faker } from "@faker-js/faker/locale/fr"
import { SourceName } from "../../../types"
import type { ApiLabStocks, LabStockPerVatRate } from "../../laboratoryStocks"

const mockVatRate = (
  vatRate: string,
  { empty = false }: { empty?: boolean } = {},
): LabStockPerVatRate => {
  if (empty) {
    return {
      vatRate,
      volume: null,
      nbDaysVolume: null,
      valueHt: null,
      valueTtc: null,
      nbDaysValueTtc: null,
      uppStockAverage: null,
      nbAdherents: null,
    }
  }

  return {
    vatRate,
    volume: faker.number.int({ min: 100, max: 30_000_000 }),
    nbDaysVolume: faker.number.int({ min: 10, max: 100_000 }),
    valueHt: faker.number.float({ min: 1_000, max: 100_000_000, fractionDigits: 2 }),
    valueTtc: faker.number.float({ min: 1_000, max: 3_000_000, fractionDigits: 2 }),
    nbDaysValueTtc: faker.number.int({ min: 30, max: 900 }),
    uppStockAverage: faker.number.int({ min: 100, max: 350 }),
    nbAdherents: faker.number.int({ min: 1, max: 1_200 }),
  }
}

export const labStocksMock = (): ApiLabStocks => ({
  laboratoryId: faker.number.int({ min: 1, max: 9_999 }),
  laboratoryName: faker.company.name(),
  periodEndDate: faker.date.recent({ days: 30 }).toISOString().slice(0, 10),
  stock: {
    volume: faker.number.int({ min: 1_000_000, max: 40_000_000 }),
    nbDaysVolume: faker.number.int({ min: 1_000, max: 10_000 }),
    valueHt: faker.number.float({
      min: 1_000_000,
      max: 150_000_000,
      fractionDigits: 2,
    }),
    valueTtc: faker.number.float({
      min: 100_000,
      max: 3_000_000,
      fractionDigits: 2,
    }),
    nbDaysValueTtc: faker.number.int({ min: 30, max: 200 }),
  },
  stockPerVatRate: [
    mockVatRate("0", { empty: true }),
    mockVatRate("2.1"),
    mockVatRate("5.5"),
    mockVatRate("10"),
    mockVatRate("20"),
  ],
  sources: [SourceName.SANTESTAT],
})
